import { atomWithReducer } from 'jotai/utils';
import { Edge, Node } from '@xyflow/react';

import { WorkflowAgent } from '@frontend/types/workflow-agent';

// @ts-expect-error: FIXME: OPAL-2388
export const initialWorkflowAgentState: WorkflowAgent = {
  id: '',
  name: '',
  agent_id: '',
  description: '',
  version: '',
  objective: '',
  plan: '',
  workflow_type: 'deterministic',
  agent_choice: null,
  max_iterations: 10,
  steps: {},
  start_step_id: '',
  variables: {},
  triggers: [],
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  created_by: null,
  is_active: true,
  is_deleted: false,
  nodes: [],
  edges: [],
};

export type WorkflowAgentAction =
  | { type: 'SET_ALL'; payload: WorkflowAgent }
  | { type: 'RESET' }
  | {
      type: 'UPDATE_FIELD';
      field: keyof WorkflowAgent;
      value: WorkflowAgent[keyof WorkflowAgent];
    }
  | {
      type: 'UPDATE_NESTED';
      field: keyof WorkflowAgent;
      value: WorkflowAgent[keyof WorkflowAgent];
    }
  | { type: 'UPDATE_STEPS'; value: WorkflowAgent['steps'] }
  | { type: 'UPDATE_VARIABLES'; value: WorkflowAgent['variables'] }
  | { type: 'UPDATE_TRIGGERS'; value: WorkflowAgent['triggers'] }
  | { type: 'UPDATE_NODES'; value: Node[] }
  | { type: 'UPDATE_EDGES'; value: Edge[] }
  | { type: 'UPDATE_NODES_AND_EDGES'; nodes: Node[]; edges: Edge[] }
  | { type: 'DELETE_NODES'; nodeIds: string[] }
  | { type: 'DELETE_EDGES'; edgeIds: string[] };

function workflowAgentReducer(state: WorkflowAgent, action: WorkflowAgentAction): WorkflowAgent {
  switch (action.type) {
    case 'SET_ALL': {
      return { ...action.payload };
    }
    case 'RESET':
      return { ...initialWorkflowAgentState };
    case 'UPDATE_FIELD':
      return { ...state, [action.field]: action.value };
    case 'UPDATE_NESTED':
      return { ...state, [action.field]: action.value };
    case 'UPDATE_STEPS':
      return { ...state, steps: action.value ?? {} };
    case 'UPDATE_VARIABLES':
      return { ...state, variables: action.value ?? {} };
    case 'UPDATE_TRIGGERS':
      return { ...state, triggers: action.value ?? [] };
    case 'UPDATE_NODES': {
      const updatedNodes = action.value;
      return { ...state, nodes: updatedNodes };
    }
    case 'UPDATE_EDGES': {
      const updatedEdges = action.value;
      return { ...state, edges: updatedEdges };
    }
    case 'UPDATE_NODES_AND_EDGES': {
      return { ...state, nodes: action.nodes, edges: action.edges };
    }
    case 'DELETE_NODES': {
      const filteredNodes = (state.nodes || []).filter(node => !action.nodeIds.includes(node.id));
      const filteredEdges = (state.edges || []).filter(
        edge => !action.nodeIds.includes(edge.source) && !action.nodeIds.includes(edge.target)
      );
      return { ...state, nodes: filteredNodes, edges: filteredEdges };
    }
    case 'DELETE_EDGES': {
      const updatedEdges = (state.edges || []).filter(edge => !action.edgeIds.includes(edge.id));
      return { ...state, edges: updatedEdges };
    }
    default:
      return state;
  }
}

export const workflowAgentAtom = atomWithReducer(initialWorkflowAgentState, workflowAgentReducer);
